<script>
export default {
	data() {
		return {
			debug: false,
		};
	},
	mounted() {
		if (this.debug) {
			console.log("SessionFilter mounted.", this.filter);
		}

		let filter_key =
				"filter_ID:" +
				this.$inertia.page.props.user?.id +
				this.$inertia.page.component,
			filter = JSON.parse(sessionStorage.getItem(filter_key));

		if (filter) {
			this.filter = filter;
			if (this.debug) {
				console.log("SessionFilter loaded.", filter);
			}
		}
	},
	watch: {
		filter: {
			deep: true,
			handler() {
				let filter_key =
					"filter_ID:" +
					this.$inertia.page.props.user?.id +
					this.$inertia.page.component;

				sessionStorage.setItem(filter_key, JSON.stringify(this.filter));

				if (this.debug) {
					console.log(
						"SessionFilter updated.",
						filter_key,
						sessionStorage.getItem(filter_key)
					);
				}
			},
		},
	},
};
</script>
